'use client'

import { useState, PropsWithChildren } from 'react'
import { Modal } from 'react-dialog-polyfill'
import { ModalModalFragment } from 'generated/graphql'
import { FC } from 'react'
import { ComponentImagePicture } from 'components/image/ComponentImagePicture/ComponentImagePicture'
import Link from 'next/link'

import styles from './Modal.Modal.module.scss'
import buttonStyles from 'styles/button.module.scss'

export const ModalModal: FC<PropsWithChildren<ModalModalFragment & {
    contextStyles?: { readonly [key: string]: string }, modalType?: string, startOpen?: boolean
}>> =
    ({
        children,
        contextStyles,
        header,
        url,
        modalType,
        startOpen,
        backgroundImage
    }) => {
    
        const [ open, setOpen ] = useState<boolean>(
            startOpen ?? false
        )

        console.log(modalType, open, header)

        return (
            <>
                <Modal
                    className={`${styles.Modal} ${contextStyles?.Modal ?? ''}`}
                    open={open}
                >
                    <header>
                        <button
                            onClick={ () => setOpen(false) }
                            className={buttonStyles.Link}
                        >
                            Close
                        </button>
                    </header>
                    <Link href={url} className={styles.Body} target='_blank'>
                        {backgroundImage?.image === undefined ? <></> :<ComponentImagePicture
                            {...backgroundImage}
                            className={styles.Image}
                        />}
                    </Link>
                </Modal>
                {modalType === 'button' ? 
                    <button
                        onClick={ () => setOpen(true) }
                        className={`${buttonStyles.Link} ${contextStyles?.Link ?? ''}`}
                    >
                        {children}
                    </button>
                    : <></>}
            </>

        )

    }
